import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dashboard-project-advancement',
  templateUrl: './dashboard-project-advancement.component.html',
  styleUrls: ['./dashboard-project-advancement.component.scss']
})
export class DashboardProjectAdvancementComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
